const state = {
    mynotifications:null,
};

const getters = {
    getMyNotifications: state => state.mynotifications,
};

const actions = {
    setMyNotifications: (store, payload) => store.commit('MYNOTIFICATIONS_SET',payload),
};

const mutations = {
    MYNOTIFICATIONS_SET: (state, payload) => state.mynotifications = payload,
};

export default {
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters,
};
